export const ACTION = {
    PAYMENT_STATUS: 'PAYMENT_STATUS',
};